export default __webpack_public_path__ + "static/media/sun.3385e771.png";